var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{model:{value:(_vm.contractStandCode),callback:function ($$v) {_vm.contractStandCode=$$v},expression:"contractStandCode"}},_vm._l((_vm.contractStandList),function(item,index){return _c('el-radio',{key:index,attrs:{"label":item.dictCode}},[_vm._v(_vm._s(item.dictName))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }